// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * What a `NotificationRecipient` row points at.
 *
 * ADDRESS (0) — a literal destination in `value` (an email address for EMAIL,
 *               a phone number for SMS/WHATSAPP). Zero value: every recipient
 *               row written before this field existed is a literal address.
 * USER    (1) — `user_id` names a user; the destination is resolved from that
 *               user's email and address book at delivery time.
 * ROLE    (2) — `role_id` names a role; the destinations are every user
 *               holding that role, resolved at delivery time so the group
 *               stays live as members join and leave.
 *
 * Values are APPEND-ONLY.
 */
export enum RecipientKind {
  ADDRESS = 0,
  USER = 1,
  ROLE = 2,
}
